import axios from "axios";

// for production api url 
// const apiUrl() = "";
axios.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	if (error.response.status === 401) {
		localStorage.clear();
		localStorage.setItem("session_expired", true);
		window.location.href = '/auth/login';
	} else {
		return Promise.reject(error);
	}
});

// responseType: 'blob' のリクエストではエラーレスポンスのJSONもBlobで返るため、
// error.response.data を通常のオブジェクトへ戻すヘルパー。
export async function parseBlobErrorResponse(error) {
	const data = error?.response?.data;
	if (data instanceof Blob && data.type && data.type.indexOf('json') !== -1) {
		try {
			error.response.data = JSON.parse(await data.text());
		} catch (e) {
			// パースできない場合は元のBlobのままにする
		}
	}
	return error;
}

const ApiService = {
	baseUrl: process.env.VUE_APP_NODE_ENV === "local" ? `http://${window.location.hostname}:8000` : window.location.origin,
	get apiUrl() { return this.baseUrl + '/api/' },
	get imageUrl() { return this.baseUrl + '/storage' },

	authHeaders() {
		return {
			"Access-Control-Allow-Headers": "Origin, Authorization, Accept",
			"Access-Control-Allow-Origin": this.baseUrl,
			"Authorization": `Bearer ${localStorage.getItem("token")}`,
			"Accept": "application/json"
		};
	},
	post(resource, params, auth = false) {
		let headers = this.authHeaders();
		return axios.post(this.apiUrl + `${resource}`, params, { headers: headers });
	},
	get(resource, params, auth = false) {
		let headers = this.authHeaders();
		return axios.get(this.apiUrl + `${resource}`, {
			params: params,
			headers: headers
		});
	},
	put(resource, params, auth = false) {
		let headers = this.authHeaders();
		return axios.put(this.apiUrl + `${resource}`, params, { headers: headers });
	},
	delete(resource, params, auth = false) {
		let headers = this.authHeaders();
		return axios.delete(this.apiUrl + `${resource}`, params, { headers: headers });
	},
	fileUpload(resource, params, auth = false) {
		return axios.post(this.apiUrl + `${resource}`, params, {
			headers: {
				...this.authHeaders(),
				"Access-Control-Allow-Headers": "Origin, Content-Type, Authorization, Accept",
				"Content-Type": "multipart/form-data",
			}
		});
	},
	setHeader() {
		let token = localStorage.getItem("userToken");
		axios.defaults.headers.common.Authorization = token;
	},
	importfileUpload(resource, params, auth = false) {
		ApiService.setHeader();
		return axios.post(this.apiUrl + `${resource}`, params, {
			headers: {
				...this.authHeaders(),
				"Access-Control-Allow-Headers": "Origin, Content-Type, Authorization, Accept",
				"Content-Type": "multipart/form-data"
			}
		});
	},
	downloadFile(resource, fileName, params, auth = false) {
		let headers = this.authHeaders();
		var FileSaver = require('file-saver');
		return axios.post(this.apiUrl + `${resource}`, params, {
			responseType: 'blob',
			headers: headers
		}).then(resp => {
			FileSaver.saveAs(resp.data, fileName);
		}).catch(async error => {
			// responseType が blob のため、エラーレスポンスのJSONもBlobで届く。
			// 呼び出し側が error.response.data.message を参照できるようJSONへ戻す。
			await parseBlobErrorResponse(error);
			return Promise.reject(error);
		});
	},
};

export default ApiService;
